import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';

import { EventStatusEnum } from '@graphql';
import { ShareMenu } from '../../common';
import EditOptions from './EditOptions';
import { HeaderProps } from './types';
import { EventCoverDialog } from '../event-form';
import { EditMode } from './EditMode';

function DesktopHeader(props: Readonly<HeaderProps>) {
  const { id, covers, isOwner, status, handleBack } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation('cta');
  const aspectRatio = isMobile ? '4/3' : '16/9';

  if (covers.length === 0 && status !== EventStatusEnum.Draft) {
    return (
      <Stack
        direction="row"
        justifyContent={'space-between'}
        p={1}
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          backdropFilter: 'blur(15px)',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
        }}
      >
        <Stack direction="row" alignItems="center" onClick={handleBack} sx={{ cursor: 'pointer' }}>
          <theme.icons.back />
          <Typography> {t('back')}</Typography>
        </Stack>
        <Stack direction="row" spacing={2} alignItems={'center'} pr={1}>
          {isOwner && <EditMode />}
          <ShareMenu type="spot" idOrSlug={id} />
          {isOwner && <EditOptions eventId={id} />}
        </Stack>
      </Stack>
    );
  }

  return (
    <>
      <EventCoverDialog />
      {/* SLIDER */}
      <Swiper
        className="mySwiper"
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true, type: 'progressbar' }}
        navigation={true}
        loop={covers.length > 1}
        style={{ width: '100%', aspectRatio }}
      >
        {covers.length > 0 ? (
          covers.map((cover) => (
            <SwiperSlide key={cover.id} style={{ width: '100%' }}>
              <img
                src={cover.url}
                alt="img"
                style={{ width: '100%', objectFit: 'cover', objectPosition: 'center', aspectRatio }}
              />
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide style={{ width: '100%' }}>
            <Stack
              pt={3}
              width="100%"
              height="100%"
              justifyContent="center"
              alignItems="center"
              sx={{
                backgroundColor: '#000',
              }}
            >
              <theme.icons.noImage />
            </Stack>
          </SwiperSlide>
        )}
      </Swiper>

      {/* HEADER */}
      <Stack
        direction="row"
        justifyContent={'space-between'}
        p={1}
        sx={{
          position: 'absolute',
          zIndex: 1,
          width: '100%',
          backdropFilter: 'blur(15px)',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
        }}
      >
        <Stack direction="row" alignItems="center" onClick={handleBack} sx={{ cursor: 'pointer' }}>
          <theme.icons.back />
          <Typography> {t('back')}</Typography>
        </Stack>
        <Stack direction="row" spacing={2} alignItems={'center'} pr={1}>
          {isOwner && <EditMode />}
          <ShareMenu type="spot" idOrSlug={id} />
          {isOwner && <EditOptions eventId={id} />}
        </Stack>
      </Stack>
    </>
  );
}

export default DesktopHeader;
